import { render, staticRenderFns } from "./MaritimContainers.vue?vue&type=template&id=937171b0&"
import script from "./MaritimContainers.vue?vue&type=script&lang=js&"
export * from "./MaritimContainers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports